import {Component} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {Usuario} from "../../app-core/model/cadastros/usuario.model";
import {LoginService} from "../../app-core/service/login.service";
import {MenuSuperiorComponent} from "./utils/menu-superior/menu-superior.component";
import {
    DetectingConnectionComponent
} from "../../app-core/utils/components/detecting-connection/detecting-connection.component";
import {DeprecatedSharedUtilsModule} from '../../app-core/utils/deprecated-shared-utils-module';

@Component({
    selector: 'layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [
        RouterOutlet,
        MenuSuperiorComponent,
        DeprecatedSharedUtilsModule,
        DetectingConnectionComponent,
        MenuSuperiorComponent,
    ]
})
export class LayoutComponent {
    message: any;
    usuarioLogado: Usuario;

    constructor(public route: Router,
                public loginService: LoginService) {
        this.usuarioLogado = this.loginService.getUser();
    }
}
